export default class LoadingQuiz {}
